<template>
  <component :is="$route.meta.layout" v-if="$route.meta.layout">
    <router-view />
  </component>
</template>

<script>
import { gsap } from 'gsap'
import * as ScrollToPlugin from "gsap/ScrollToPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { mapActions, mapState } from 'vuex'

export default {
  metaInfo: {
    titleTemplate: '%s | ACEM Resources',
    meta: [
      {
        name: 'Description',
        content: 'Common Presentations'
      },
      {
        property: 'og:title',
        content: 'Home',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk} - ACEM Resources`,
        vmid: 'og:title'
      },
    ],
    link: [
      { rel: 'canonical', href: 'https://edmentalhealth.acem.org.au' }
    ]
  },

  data () {
    return {
      loading: true,
    }
  },

  created () {
    this.checkAuthentication()
    // when the token gets created, set the defaults for axios
    // The "Axios" vuex instance also gets updated, but via router.js
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'Auth/SET_JWT_TOKEN') {
        if (mutation.payload) this.axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
      }
    })

    // Need to register the scroll plugin for scroll to work throughout the app
    gsap.registerPlugin(ScrollToPlugin)
    gsap.registerPlugin(ScrollTrigger)
  },

  computed: {
    ...mapState('Auth', ['token'])
  },

  methods: {
    ...mapActions('App', ['getPages']),
    ...mapActions('Auth', ['checkAuthentication']),
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/styles.scss';
</style>
